import {ComponentRef, Injectable, Injector, Type, ViewContainerRef} from "@angular/core";
import {delay, Observable, Subject} from "rxjs";

@Injectable()
export class FUIModalsService {
    public modals: Array<ComponentRef<any>> = new Array<ComponentRef<any>>();
    public placeholder: ViewContainerRef;
    public $placeHolderChanged: Subject<void> = new Subject<void>();

    /**
     *
     * @param instance
     * @param delayMs
     * @returns {any}
     */
    close<T>(instance: T, delayMs: number = 250): Observable<T> {
        instance["state"] = false;

        /**
         * Returning an observable so that actions can be performed
         * in an order - close and then destroy, for instance
         */
        return new Observable<T>((observer) => {
            observer.next(instance);
            observer.complete();
        }).pipe(delay(delayMs));
    }

    /**
     *
     * @param modal
     * @param injector
     * @param delayMs
     * @returns {any}
     */
    create<T>(modal: Type<T>, injector?: Injector, delayMs: number = 250): Observable<T> {
        return new Observable<T>((observer) => {
            const componentRef: ComponentRef<T> = this.placeholder.createComponent(modal, {injector: injector});
            componentRef.instance["modal"] = componentRef;

            this.modals.push(componentRef);

            observer.next(componentRef.instance);
            observer.complete();
        }).pipe(delay(delayMs));
    }

    /**
     * Remove the component from the DOM
     * @param instance
     */
    destroy(instance: any): Observable<void> {
        for (const modal of this.modals) {
            if (modal.instance === instance) {
                modal.destroy();
                this.modals.slice(this.modals.indexOf(modal), 1);
            }
        }

        return new Observable<void>((observer) => {
            /**
             * Return an empty instance of an alert
             * to allow clearing at the client of the
             * created instance.
             */
            observer.next();
            observer.complete();
        })
    }

    /**
     *
     * @param instance
     * @param delayMs
     * @returns {any}
     */
    open<T>(instance: T, delayMs: number = 250): Observable<T> {
        instance["state"] = true;

        return new Observable<T>((observer) => {
            observer.next(instance);
            observer.complete();
        }).pipe(delay(delayMs));
    }

    /**
     *
     * @param viewContainerRef
     */
    setPlaceholder(viewContainerRef: ViewContainerRef) {
        this.placeholder = viewContainerRef;
        this.modals = new Array<ComponentRef<any>>();
        this.$placeHolderChanged.next();
    }
}
